import { render, staticRenderFns } from "./showPirceInfo.vue?vue&type=template&id=a63b6a42&scoped=true"
import script from "./showPirceInfo.vue?vue&type=script&lang=js"
export * from "./showPirceInfo.vue?vue&type=script&lang=js"
import style0 from "./showPirceInfo.vue?vue&type=style&index=0&id=a63b6a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63b6a42",
  null
  
)

export default component.exports